export var getRegionNameById = function (id, regions) {
    var region = regions.find(function (r) { return r.id === id; });
    return region && region.name ? region.name : "";
};
//# sourceMappingURL=getRegionNameById.js.map